export default "__VITE_ASSET__a5303c0d__"